import React, { useCallback, useEffect, useState } from 'react';
import { useListUserTagsQuery } from '../../api';
import ListPagination from '../../components/ListPagination';
import { TagEditDialog, TagHeader, TagTable } from './components';

const pageSize = 10;

const TagManagement = () => {
    const [{ page, search }, setListContext] = useState({ page: 0, search: '' });
    const [activeTagId, setActiveTagId] = useState<string | null>(null);
    const [showCreate, setShowCreate] = useState(false);
    const { data, refetch } = useListUserTagsQuery({
        fetchPolicy: 'cache-and-network',
        variables: { page: { limit: pageSize, offset: page * pageSize }, search },
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [page]);

    const searchOnChange = useCallback((searchValue: string) => {
        setListContext({ page: 0, search: searchValue });
    }, []);

    const setActivePage = useCallback((newPage: number) => {
        setListContext(state => ({ ...state, page: newPage }));
    }, []);

    const onUpdates = useCallback(async () => {
        await refetch();
    }, [refetch]);

    const tags = data?.userTags.items || [];

    return (
        <>
            <TagHeader onCreate={() => setShowCreate(true)} search={search} searchOnChange={searchOnChange} />
            <TagTable onEdit={setActiveTagId} onUpdates={onUpdates} tags={tags} />
            <ListPagination
                activePage={page + 1}
                count={data?.userTags.count || 0}
                pageSize={pageSize}
                setActivePage={setActivePage}
            />
            <TagEditDialog
                onClose={() => {
                    setShowCreate(false);
                    setActiveTagId(null);
                }}
                onUpdates={onUpdates}
                open={showCreate || !!activeTagId}
                tag={tags.find(item => item.id === activeTagId) || null}
            />
        </>
    );
};

export default TagManagement;
